// 为对象属性值去除空格
// {name: ' moon ', age: 10} => {name: 'moon', age: 10}
const trimProps = (source) => {
  Object.keys(source).forEach((key) => {
    if (typeof source[key] === 'string') {
      // eslint-disable-next-line no-param-reassign
      source[key] = source[key].trim();
    }
  });
};

export default { trimProps };
